import React from "react";
import ErrorPage from "./views/ErrorPage";

const ErrorPage404 = () => {
  return <ErrorPage />;
};

export default ErrorPage404;
